'use client';

import { Skeleton } from "@/components/ui/skeleton";
import { useEffect } from "react";

const ContentLoading = ({ title = 'Running Content Analysis...' }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <div className="flex-1 w-full flex flex-col items-center justify-center p-4 gap-4">
      <div className="relative w-full lg:w-1/2 flex flex-col gap-8">
        <div className="text-2xl md:text-3xl lg:text-4xl font-semibold flex items-center gap-2 justify-center">
          <span className="animate-bounce">🔍</span>
          <h1>{title}</h1>
        </div>
        <div className="flex flex-col gap-4 fade-half bg-white">
          <div className="flex gap-4">
            <Skeleton className="h-32 w-1/3 rounded-xl" />
            <div className="h-32 w-2/3 gap-4 flex flex-col">
              <Skeleton className="w-full h-1/3 rounded-xl" />
              <Skeleton className="w-full h-1/3 rounded-xl" />
              <Skeleton className="w-full h-1/3 rounded-xl" />
            </div>
          </div>
          <Skeleton className="h-16 w-full rounded-xl" />
          <Skeleton className="h-12 w-full rounded-xl" />
          <Skeleton className="h-8 w-full rounded-xl" />
          <Skeleton className="h-12 w-full rounded-xl" />
        </div>
      </div>
    </div>
  )
}

export default ContentLoading;
